import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FARMA, structure } from '../farmaferContent';

const Structure = () => (
  <Box
    component="section"
    id="estructura"
    py={{ xs: 7, md: 10 }}
    px={{ xs: 2.5, sm: 4, md: 7 }}
    bgcolor={FARMA.mist}
  >
    <Box maxWidth={1100} mx="auto">
      <Typography
        sx={{
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          fontSize: '0.75rem',
          color: FARMA.green,
          mb: 1.25,
        }}
      >
        {structure.overline}
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          fontWeight: 800,
          letterSpacing: '-0.03em',
          fontSize: { xs: '1.85rem', md: '2.55rem' },
          color: FARMA.ink,
          mb: 1.25,
          maxWidth: 640,
        }}
      >
        {structure.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: '"Source Sans 3", "Outfit", sans-serif',
          color: FARMA.inkMuted,
          fontSize: { xs: '1.05rem', md: '1.12rem' },
          lineHeight: 1.65,
          maxWidth: 620,
          mb: { xs: 4, md: 5 },
        }}
      >
        {structure.subtitle}
      </Typography>

      <Grid container spacing={0}>
        {structure.modules.map((mod, index) => (
          <Grid item xs={12} md={6} key={mod.id}>
            <Box
              py={{ xs: 3, md: 3.5 }}
              pr={{ md: index % 2 === 0 ? 4 : 0 }}
              pl={{ md: index % 2 === 1 ? 4 : 0 }}
              borderTop={`1px solid ${FARMA.sand}`}
              sx={{
                transition: 'transform 0.35s ease',
                '&:hover': { transform: 'translateX(4px)' },
              }}
            >
              <Typography
                sx={{
                  fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                  fontWeight: 800,
                  fontSize: '0.8rem',
                  color: FARMA.greenSoft,
                  letterSpacing: '0.08em',
                  mb: 0.75,
                }}
              >
                {String(index + 1).padStart(2, '0')}
              </Typography>
              <Typography
                component="h3"
                sx={{
                  fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                  fontWeight: 800,
                  fontSize: { xs: '1.35rem', md: '1.5rem' },
                  color: FARMA.ink,
                  mb: 1,
                }}
              >
                {mod.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                  color: FARMA.inkMuted,
                  lineHeight: 1.7,
                  fontSize: '1.02rem',
                }}
              >
                {mod.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default Structure;
